<script lang="ts">
	export let count: number
</script>

{#if count}
	<div
		class="h-5 w-5 flex text-xs items-center justify-center rounded-full bg-red-500 text-white absolute -right-1 -top-1"
	>
		{count < 99 ? count : '99+'}
	</div>
{/if}
